export default {
  portalMediaParallax: 'portalMediaParallax'
};
